// src/views/SavedQuery/SavedQuery.style.js
import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";

export const THEME = {
  primary: "rgb(44, 52, 123)",
  primaryRgba: (a) => `rgba(44, 52, 123, ${a})`,
  hover: "rgb(35, 42, 100)",
};

/** Main card wrapper - matches Collaboration layout */
export const MainCard = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  width: "100%",
  backgroundColor: "#ffffff",
  borderRadius: 8,
  border: "1px solid #e2e8f0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  overflow: "hidden",
});

/** Tabs container - tab bar style */
export const TabsRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 0,
  padding: "0 12px",
  borderBottom: "1px solid #e2e8f0",
  backgroundColor: "#ffffff",
  flexShrink: 0,
});

/** Tab button - active (underline tab style) */
export const TabButtonActive = styled(Button)({
  borderRadius: 0,
  fontWeight: 600,
  fontSize: "0.8rem",
  px: 1.5,
  py: 0.75,
  color: THEME.primary,
  backgroundColor: "transparent",
  borderBottom: `2px solid ${THEME.primary}`,
  marginBottom: -1,
  "&:hover": {
    backgroundColor: THEME.primaryRgba(0.06),
  },
});

/** Tab button - inactive (tab style) */
export const TabButtonInactive = styled(Button)({
  borderRadius: 0,
  fontWeight: 500,
  fontSize: "0.8rem",
  px: 1.5,
  py: 0.75,
  color: "#64748b",
  backgroundColor: "transparent",
  borderBottom: "2px solid transparent",
  marginBottom: -1,
  "&:hover": {
    color: THEME.primary,
    backgroundColor: THEME.primaryRgba(0.04),
  },
});

/** Empty state icon box */
export const EmptyIconBox = styled(Box)({
  width: 72,
  height: 72,
  borderRadius: 12,
  backgroundColor: THEME.primaryRgba(0.08),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 auto 16px",
});
